<template>
  <div>
    <b-table
      style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: 5px; margin-top: 12px"
      :items="vorgangData"
      :fields="vorgangFields"
      responsive
      hover
      head-variant="light"
      @row-clicked="rowClicked"
    >
      <template v-slot:cell(kundenname)="row">
        <div style="width: 170px">
          {{ kundenName(row.item) }}
        </div>
      </template>
      <template v-slot:cell(blankState)="row">
        <VorgangStateWidget v-if="row.item?.blankState" :state="row.item?.blankState" />
      </template>

      <template v-slot:cell(aufgaben)="row">
        <b-badge :id="'tooltip-target-vorgang' + row.item.id">
          {{ row.item.aufgaben?.length }}
        </b-badge>
        <b-tooltip
          :target="'tooltip-target-vorgang' + row.item.id"
          triggers="hover"
          custom-class="custom-tooltip"
          v-if="row.item.aufgaben?.length > 1"
        >
          <AufgabenWidget
            :openAufgabenId="openAufgabenId"
            class="mt-3"
            :ansicht="'aufgabe-details'"
            :aufgaben="row.item.aufgaben || []"
          ></AufgabenWidget>
        </b-tooltip>
      </template>
    </b-table>
  </div>
</template>
<script>
import VorgangStateWidget from '@/components/vorgaenge/vorgang-state-widget.vue';
import AufgabenWidget from '@/components/produkte/reisetermine/aufgaben-widget.vue';

export default {
  components: { VorgangStateWidget, AufgabenWidget },
  props: {
    vorgangData: { type: Array, required: true },
    openAufgabenId: { type: Number, default: null },
    reiseTermine: { type: Array, default: () => [] },
  },
  data() {
    return {
      vorgangFields: [
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'id',
          label: 'BNR',
        },
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'kundenname',
        },
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'zimmer',
          formatter: value => value.join(', '),
        },
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'npx',
          label: 'PAX',
        },
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'blankState',
          label: 'Buchungsstatus',
        },
        {
          tdClass: 'align-middle',
          thStyle: { width: '16.66%' },
          key: 'aufgaben',
          label: 'Aufgaben',
        },
      ],
    };
  },
  methods: {
    kundenName(item) {
      if (item?.kunde?.master) {
        return item?.kunde?.master.vorname + ' ' + item?.kunde?.master.nachname;
      } else return '';
    },
    rowClicked(item) {
      // für die Katalog Reise, da es dort einen Reisetermin gibt
      if (this.reiseTermine?.length > 0) {
        const query = this.reiseTermine[0]?.reiseterminkuerzel
          ? `?reiseterminkuerzel=${this.reiseTermine[0]?.reiseterminkuerzel}`
          : '';
        window.open(`/#/vorgaenge/rechnungspruefung/katalog-reisen${query}`, '_blank');
      } else {
        // für die FIT Reise, da es dort keinen Reisetermin gibt
        window.open(`/#/vorgaenge/rechnungspruefung/fit-reisen?vorgangId=${item.id}`, '_blank');
      }
    },
  },
};
</script>
<style>
.custom-tooltip .tooltip-inner {
  max-height: 500px;
  overflow-y: auto;
  text-align: left;
}
</style>
